export default "__VITE_ASSET__I5GL0eTD__"